module.exports = __webpack_public_path__ + "d86f4681b483df5a724fd1db0420191c.png";